import React from 'react'

function UploadDoc() {
  return (
    <div>UploadDoc</div>
  )
}

export default UploadDoc